import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { PermissionsPage } from "@/features/domain/components/permissions-page";
import { useI18n } from "@/providers/i18n-provider";

function PermissionsRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Roles & permissions`)}
      description={t(msg`Sign in to manage roles and granular permissions.`)}
    >
      <PageContainer maxWidth="3xl">
        <PermissionsPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const permissionsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/permissions",
  component: PermissionsRoutePage,
});
